export default __webpack_public_path__ + "static/media/Edie 9781408304761.fe6f1cb6.jpg";